/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types */
class ErrorHelperImpl
{
    toJson(error?: Error | unknown): Record<string, unknown> | undefined
    {
        if (error === null || error === undefined)
        {
            return undefined;
        }

        if (this.hasToJSON(error))
        {
            return error.toJSON();
        }

        const alt: Record<string, unknown> = {};

        Object.getOwnPropertyNames(error)
            .forEach((key: string) =>
            {
                switch (key)
                {
                    case "message": {
                        const message = (error as any)[key] as string;
                        alt[key] = message;
                        break;
                    }
                    case "codeFrame":
                    case "stack":
                        {
                            const stack = (error as any)[key] as string;
                            const frames = stack.split(/\r?\n/);
                            alt[key] = frames.map(x =>
                            {
                                return x.replace(/\\/g, "/");
                            });
                            break;
                        }
                    case "innerError":
                        alt[key] = this.toJson((error as any)[key]);
                        break;
                    default: {
                        const value = (error as any)[key];
                        alt[key] = value;
                        break;
                    }
                }
            }, error);

        return alt;
    }

    private hasToJSON<T>(value: T): value is T & HasToJSON
    {
        return !!value && typeof value === "object" && "toJSON" in value;
    }
}

interface HasToJSON
{
    toJSON(): Record<string, unknown> | undefined;
}

export const ErrorHelper = new ErrorHelperImpl();
